import React from 'react';
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Button,
    FormGroup
} from 'reactstrap';
import ErrorModal from './errorModal';
import { API_ENDPOINT } from '../constants';
import CustomID from './forms/fields/customIdField';
import Isvg from 'react-inlinesvg';
import infoIcon from "../assets/svg/link-new-tab.svg";

function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}

/**
* Custom id modal
* @author   Stefan Pantic
*/
class CustomIdModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            groupObj: null,
            customId: '',
        }
    }

    getGroupId = () => {
        let groupAlias;
        if (typeof window != 'undefined' && localStorage.groupAlias) {
            groupAlias = localStorage.groupAlias;
        } else if (this.props[0].match.params.alias) {
            groupAlias = this.props[0].match.params.alias;
        }

        if (groupAlias) {


            fetch(API_ENDPOINT + "/data/clinic-group/info", {
                method: "POST",
                headers: {
                    Authorization:
                        typeof localStorage !== "undefined"
                            ? `Bearer ${localStorage.getItem("authToken")}`
                            : null,
                    "content-type": "application/json",
                },
                body: JSON.stringify({ alias: groupAlias }),
            }).then(parseJSON).then(({ result, status }) => {
                if (result && result._id) {
                    this.setState({ groupObj: result, customIdModal: true }, () => {
                        return result._id;
                    })

                }
            });
        }
        return null
    }

    componentDidMount() {
        if (!this.state.groupObj) {
            this.getGroupId();
        }
    }

    updatePatientProfile = (obj) => {

        let data = {
            // email: obj.email,
            // phone: obj.phone,
            // city: obj.city,
            // street: obj.street,
            // zip: obj.zip,
            // userData: obj.userData,
            // customId: obj.customId,
            ...obj
        }

        if (this.state.groupObj?._id) {
            data.group = this.state.groupObj?._id
        }

        this.setState({
            loading: true
        }, () => {
            fetch(API_ENDPOINT + '/users/account/update', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (!result.error) {
                    this.setState({ customIdModal: false });
                } else {
                    this.setState({
                        error: result.error
                    })
                }

            })
        })
    }

    render() {
        const patientInfoSettings = this.state.groupObj?.patientInfoSettings || {};
        return (

            this.props.uData && (this.props.uData.userLevel == 1 || this.props.uData.userLevel == 2 || (typeof window != 'undefined' && localStorage.getItem('profile') == 'patient')) && this.state.groupObj?.patientInfoSettings?.isCustomIdEnabled && this.state.groupObj?.patientInfoSettings?.isCustomIdRequired && (!this.props.uData?.customId || !this.props.uData?.customId[this.state.groupObj?._id]) ?
                <Modal centered isOpen={this.state.customIdModal} className="custom-id-modal">
                    <ModalHeader  >
                        <div className='custom-id-label-wrap'>
                            <div>{patientInfoSettings?.customIdLabel ? patientInfoSettings?.customIdLabel : 'Custom id'.translate(this.props.lang)}</div>
                            {
                                patientInfoSettings?.customIdInfoText ?
                                    <div className='info' >
                                        <Isvg src={infoIcon} />
                                        <div className="info-text">{patientInfoSettings?.customIdInfoText ? patientInfoSettings?.customIdInfoText : ''}</div>
                                    </div>
                                    :
                                    null
                            }
                        </div>


                    </ModalHeader>
                    <ModalBody>
                        <CustomID
                            value={this.state.customId}
                            // label={patientInfoSettings?.customIdLabel ? patientInfoSettings?.customIdLabel : 'Custom id'.translate(this.props.lang)}
                            // labelInfo={patientInfoSettings?.customIdInfoText ? patientInfoSettings?.customIdInfoText : null}
                            onChange={(val) => {
                                if (val.length <= 20)
                                    this.setState({
                                        customId: val,
                                        error: null
                                    });
                            }}
                        />
                        {
                            this.state.error ?
                                <FormGroup>
                                    <p style={{ color: 'red' }}>{this.state.error}</p>
                                </FormGroup>
                                :
                                null
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button disabled={!this.state.customId} color="primary" onClick={() => {
                            if (this.state.customId !== '' && this.state.groupObj) {
                                this.updatePatientProfile({ ...this.props.uData, customId: { ...this.props.uData?.customId, [this.state.groupObj._id]: this.state.customId } });

                            }

                        }}>{'Save'.translate(this.props.lang)}</Button>
                    </ModalFooter>
                </Modal>
                :
                null
        )
    }
}

export default CustomIdModal;